"use client"

import { useEffect, useState } from "react"
import press1 from "../assets/jami2.png"
import press3 from "../assets/jami3.png"
import press4 from "../assets/press2.jpg"
import event1 from "../assets/beremlFest.JPG"
import event2 from "../assets/bermel1.jpg"
import event3 from "../assets/bermel2.jpg"
import event4 from "../assets/bermel4.jpg"
import Release from "../assets/brew4.jpg"
import Release2 from "../assets/brew3.jpg"
import Release3 from "../assets/brew2.jpg"
import Release4 from "../assets/brew4.jpg"
import video from "../assets/launch.mp4"
import founder1 from "../assets/Founder1.jpg"
import founder2 from "../assets/Founder2.jpg"
import founder3 from "../assets/Founder3.jpg"
import founder4 from "../assets/Founder4.jpg"
import founder5 from "../assets/Founder5.jpg"
import founder6 from "../assets/Founder6.jpg"
import styles from "../styles/Events.module.css"
import { Search, Calendar, MapPin, Users, ArrowRight } from "lucide-react"
import { Link, useLocation } from "react-router-dom"
import Header from "../components/Header"
import Footer from "../components/Footer"

const ImageCarousel = ({ images }) => {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length)
    }, 4000)
    return () => clearInterval(timer)
  }, [images])

  return (
    <div className={styles.carouselContainer}>
      <img src={images[index] || "/placeholder.svg"} alt={`slide-${index}`} className={styles.carouselImage} />
      <div className={styles.carouselIndicators}>
        {images.map((_, i) => (
          <button
            key={i}
            className={`${styles.indicator} ${i === index ? styles.activeIndicator : ""}`}
            onClick={() => setIndex(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  )
}

const featuredBlogPosts = [
  {
    id: 1,
    title: "Founders Friday Event",
    imageUrls: [founder1, founder2, founder3, founder4, founder5, founder6],
    date: "15 Aug 2025",
    objective:
      "OBJECTIVE: To amplify startup visibility, foster knowledge exchange, and spark collaborations among founders, innovators, and industry leaders from diverse backgrounds.",
    excerpt:
      "Founders' Friday is a monthly celebration of innovation where selected startup founders light up the stage with their entrepreneurial journeys. Expect captivating pitches, live product demos, and interactive sessions that let you experience groundbreaking ideas firsthand. Connect with a vibrant community of dreamers and doers, and turn your ideas into impact. Brought to you by Arifpay & WeVenture, this is where the future of business begins!",
    // link: "/Founders-Friday",
    location: "Addis Ababa",
    attendees: "150+",
    featured: true,
  },
  {
    id: 2,
    title: "Jami Launching Event",
    imageUrls: [press1, press3, press4],
    date: "02 May 2025",
    excerpt: "Jami Launching Event",
    location: "Addis Ababa",
    attendees: "200+",
  },
  {
    id: 3,
    title: "Arifpay @ Bermel Event",
    imageUrls: [event1, event2, event3, event4],
    date: "18 May 2025",
    excerpt: "Arifpay @ Bermel Event",
    location: "Addis Ababa",
    attendees: "300+",
  },
  {
    id: 4,
    title: "Events Book and Brew",
    imageUrls: [Release, Release2, Release3, Release4],
    date: "17 May 2025",
    excerpt: "Events Book and Brew",
    location: "Addis Ababa",
    attendees: "100+",
  },
  {
    id: 5,
    title: "Arif 3.0 Launching Event",
    videoUrl: video,
    date: "12 Dec 2024",
    excerpt: "Arif 3.0 Launching Event",
    location: "Addis Ababa",
    attendees: "250+",
  },
]

const Events = () => {
  const location = useLocation()
  const [searchQuery, setSearchQuery] = useState("")
  const [activeFilter, setActiveFilter] = useState("all")

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  const filteredEvents = featuredBlogPosts.filter((post) => {
    const matchesSearch =
      post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      post.objective.toLowerCase().includes(searchQuery.toLowerCase())||
      post.excerpt.toLowerCase().includes(searchQuery.toLowerCase())
    return matchesSearch
  })

  return (
    <div>
      <Header />
      <div className={styles.pageWrapper}>

      <section className={styles.heroSection}>
        <div className={styles.heroContent}>
          <span className={styles.heroLabel}>EVENTS</span>
          <h1 className={styles.heroTitle}>Discover Our Latest Events</h1>
          <p className={styles.heroDescription}>
            Join us for exciting gatherings, product launches, and community celebrations
          </p>
        </div>
      </section>

      <div className={styles.container}>
        <div className={styles.maxWidth}>
          <div className={styles.controlsBar}>
            <div className={styles.filterButtons}>
              <button
                className={`${styles.filterBtn} ${activeFilter === "all" ? styles.activeFilter : ""}`}
                onClick={() => setActiveFilter("all")}
              >
                All Events
              </button>
          <div className={styles.tooltipWrapper}>
  <button
    className={`${styles.filterBtn} ${styles.disabledBtn}`}
    disabled
  >
    Upcoming
  </button>
  <span className={styles.tooltipText}>
    ✨ Stay tuned! Exciting events are on the way!
  </span>
</div>

        
            </div>
{/* 
            <div className={styles.searchBox}>
              <Search className={styles.searchIcon} />
              <input
                type="text"
                placeholder="Search events..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className={styles.searchInput}
              />
            </div> */}
          </div>

          <div className={styles.eventsGrid}>
            {filteredEvents.map((post, idx) => (
              <Link
                key={post.id}
                to={post.link || "#"}
                className={`${styles.eventCard} ${post.featured ? styles.featuredCard : ""} ${idx === 0 ? styles.largeCard : ""}`}
              >
                <div className={styles.eventImageWrapper}>
                  {post.videoUrl ? (
                    <video className={styles.eventMedia} src={post.videoUrl} autoPlay muted loop playsInline />
                  ) : post.imageUrls?.length > 1 ? (
                    <ImageCarousel images={post.imageUrls} />
                  ) : (
                    <img
                      src={post.imageUrls?.[0] || "/placeholder.svg"}
                      alt={post.title}
                      className={styles.eventMedia}
                    />
                  )}
                  <div className={styles.eventOverlay}>
                    <div className={styles.eventBadge}>
                      <Calendar size={14} />
                      <span>{post.date}</span>
                    </div>
                  </div>
                </div>

                <div className={styles.eventContent}>
                  <h3 className={styles.eventTitle}>{post.title}</h3>
{post.objective && (
  <p 
    style={{ color: 'white', fontSize: '18px', lineHeight: '1.4', marginBottom: '2px' }} 
    className={styles.eventObjective}
  >
    {post.objective}
  </p>
)}
                  <p className={styles.eventExcerpt}>{post.excerpt}</p>

                  <div className={styles.eventMeta}>
                    <div className={styles.metaItem}>
                      <MapPin size={16} />
                      <span>{post.location}</span>
                    </div>
                    <div className={styles.metaItem}>
                      <Users size={16} />
                      <span>{post.attendees}</span>
                    </div>
                  </div>
{/* 
                  <div className={styles.eventAction}>
                    <span>View Details</span>
                    <ArrowRight size={18} />
                  </div> */}
                </div>
              </Link>
            ))}
          </div>

          {/* <section className={styles.newsletterSection}>
            <div className={styles.newsletterContent}>
              <h2 className={styles.newsletterTitle}>Stay Updated</h2>
              <p className={styles.newsletterText}>
                Subscribe to our newsletter for the latest event updates and exclusive invitations
              </p>
              <form className={styles.newsletterForm}>
                <input type="email" placeholder="Enter your email" className={styles.newsletterInput} />
                <button type="submit" className={styles.newsletterButton}>
                  Subscribe
                </button>
              </form>
            </div>
          </section> */}
        </div>
      </div>
      </div>

      <Footer />
    </div>
  )
}

export default Events
